import styled from "styled-components";
import { device } from "../../config/sizes";

export const ContentWrapper = styled.div<{ bigMargins?: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 10rem 5rem 5rem;
  min-height: 100vh;
  margin: 0 auto;
  max-width: 1200px;
  position: relative;

  a {
    color: black;

    &:hover {
      text-decoration: none;
    }
  }

  video.content {
    padding: 7.5vh 0 7.5vh 0;
  }

  img {
    width: 70%;
    align-self: center;
  }

  img.content {
    padding: 7.5vh 0 7.5vh 0;
  }

  img.width-fifty {
    width: 50%;
  }

  img.width-eighty {
    width: 80%;
  }

  @media ${device.mobile} {
    min-height: auto;
    padding: ${({ bigMargins }) => (bigMargins ? "7rem 3rem 8rem" : "3rem")};

    img {
      width: 100%;
    }
  }
`;
